<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/xuqiu/Lmanagement',title:'协同管理'},{title:'协同部门配置'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                          <el-form-item label="产品编码" >
                            <el-input v-model="q.materialCode" placeholder="请输入名称/编码" :clearable="true"></el-input>
                          </el-form-item>
                          <el-form-item label="产品大类">
                              <brselect category="product_level" :v="q.oneLid" v-model="q.oneLid" :clearable="true"
                                        style="width:100%"/>
                          </el-form-item>
                        </div>
                      <div class="l-screenBox">
                        <div class="l-retrieval">
                          <el-form-item>
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                                       @click="addEditDialog">新增
                            </el-button>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              :border="true"
                              stripe
                              max-height="500"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                :show-overflow-tooltip="true"
                                style="width:15%"
                                label="产品名称">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
                                style="width:15%"
                                :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column
                                prop="prodseries"
                                :show-overflow-tooltip="true"
                                style="width:10%"
                                label="产品大类">
                        </el-table-column>
                        <el-table-column
                                prop="oneLid"
                                :show-overflow-tooltip="true"
                                style="width:10%"
                                label="大类编码">
                        </el-table-column>
                        <el-table-column
                                prop="dbrname"
                                :show-overflow-tooltip="true"
                                style="width:15%"
                                label="审批人名称">
                        </el-table-column>
                        <el-table-column
                                prop="dbrcode"
                                :show-overflow-tooltip="true"
                                style="width:15%"
                                label="审批人编码">
                        </el-table-column>
                        <el-table-column
                                prop="cucode"
                                :show-overflow-tooltip="true"
                                style="width:15%"
                                label="创建人">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
                                style="width:15%"
                                label="创建时间">
                        </el-table-column>
                      <el-table-column
                              fixed="right"
                              label="操作"
                              style="width:10%">
                          <template slot-scope="scope">
                              <div class="w-caozuo" style="text-align: left;">
                                  <el-button
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn" @click="addEditDialog(scope.row,'edit')">
                                      修改
                                  </el-button>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="bscProductControlExcel"
                                    :startrow="2"
                                    :extparams="q"
                                    @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--    表格结束-->
        <!--    新增和编辑弹窗开始-->
        <el-dialog :close-on-click-modal="false" class="new-dialog" :visible.sync="dialogFormVisible">
            <!-- dialogImg -->
            <div class="h-dialogImg">
                <h3>{{ this.title }}</h3>
            </div>
            <el-form :model="addEditFrom" ref="addEditFrom" label-width="80px" :rules="rules" :inline="true" size="mini"
                     class="addDeliveryForm">
                <el-form-item v-if="addEditFrom.optionsType === 'add'" label="产品大类" prop="oneLid">
                    <brselectlazy category="product_level" :v="addEditFrom.oneLid" @change="callFun"
                                  v-model="addEditFrom.oneLid"
                                  :clearable="true"
                    />
                </el-form-item>
                <el-form-item v-else label="产品大类" prop="prodseries">
                    <el-select v-model="addEditFrom.prodseries"
                               disabled
                               clearable>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品名称" prop="materialName">
                    <!-- @change="productChange" -->
                    <el-select v-model="addEditFrom.materialName" placeholder="请选择"  @change="productChange"
                               filterable>
                        <el-option v-for="item in productNameArr" :key="item.levelname + item.id"
                                   filterable :label="item.levelname" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="产品编号" prop="materialCode">
                    <el-select v-model="addEditFrom.materialCode" placeholder="请选择"  @change="productCode"
                               filterable>
                        <el-option v-for="item in proudctLevelArr" :key="item.id"
                                   filterable :label="item.id" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批人名称" prop="dbrname">
                    <el-select v-model="addEditFrom.dbrname"
                               :title="addEditFrom.dbrname"
                               remote filterable :filter-method="selectUser" clearable  placeholder="请输入"
                               :remote-method="selectUser" @change="changeUser($event)" >
                        <el-option v-for="(item) in userList"
                                   :key="item.username"
                                   :label="item.username +'-'+ item.usercode"
                                   :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="()=>dialogFormVisible=false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import supplierAreaService from "../../../api/dingd/supplierArea"

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                //表格
                multipleSelection: [],
                canjobpoint:true,
                isImport:false,
                //导入Excel
                uploaddownexcelflag: false,
                showdizhiflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                title:null,
                areaList:[],
                channelList:[],
                //临时的id
                iditem:'',
                userInfo: {
                    usercode: null,
                    username: null,
                },
                //分页/检索
                q: {
                    materialCode:null,
                    oneLid:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                f:{
                },
                //新增和编辑
                addEditFrom: {
                    id:'',
                    oneLid: '',//产品大类编号
                    optionsType:'',
                    prodseries: '',//产品大类名称
                    materialName: '',//产品名称
                    materialCode: '',//产品id
                    dDeliveryIdelivery: '',//
                    dbrname:'',
                    dbrcode:'',
                    optionsType:''
                },
                //链群
                JobGroup: [],
                JobPoint:[],
                //table列表
                tableData: [],
                supplierList:[],
                userList:[],
                //弹窗
                dialogFormVisible: false,
                productNameArr: [],//弹窗中产品名称集合
                proudctLevelArr:[],
              rules: {
                supplierName:[{required: true, message: '供应商名称必填', trigger:['change', ' blur','input']}],
                supplierCode:[{required: true, message: '供应商编码必填', trigger: 'change'}],
              },
            }
        },
        created() {
            this.query();
            this.channelList = this.$store.getters.dictlist("sales_region");
            this.areaList = this.$store.getters.dictlist("target_area");
            this.isImport = this.$store.getters.hasRole('swyl_admin,swyl_shfw');
        },
        methods: {
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.customerCode = null;
                this.q.area = null;
                this.q.channel = null;
                this.q.user = null;
            },
            query() {
                ss.chanpin.selectProductControlPage(this.q).then(rd => {
                    console.log(rd)
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            //点击新增或编辑
            addEditDialog(row, type) {
                this.dialogFormVisible = true;
                if (type == 'edit') { //编辑
                    this.title = '产品管制修改';
                    this.$set(this.addEditFrom, 'id', row.id);
                    this.$set(this.addEditFrom, 'optionsType', 'edit');
                    this.$set(this.addEditFrom, 'oneLid', row.oneLid);//产品大类编号
                    this.$set(this.addEditFrom, 'prodseries', row.prodseries);//产品大类编号
                    this.$set(this.addEditFrom, 'materialName', row.materialName);//产品名称
                    this.$set(this.addEditFrom, 'materialCode', row.materialCode);//产品名称编码
                    this.$set(this.addEditFrom, 'dbrname', row.dbrname);//审批人名称
                    this.$set(this.addEditFrom, 'dbrcode', row.dbrcode);//审批人编码
                } else {
                    this.title = '产品管制新增';
                    this.proudctLevelArr = []
                    this.addEditFrom.productId = ''
                    console.log(this.title)
                    this.$set(this.addEditFrom, 'optionsType', 'add');
                    this.$set(this.addEditFrom, 'oneLid', row.oneLid);//产品大类编号
                    this.$set(this.addEditFrom, 'prodseries', row.prodseries);//产品大类编号
                    this.$set(this.addEditFrom, 'materialName', row.materialName);//产品名称
                    this.$set(this.addEditFrom, 'materialCode', row.materialCode);//产品名称编码
                    this.$set(this.addEditFrom, 'dbrname', row.dbrname);//审批人名称
                    this.$set(this.addEditFrom, 'dbrcode', row.dbrcode);//审批人编码
                }
            },
            //用户名列表
            selectUser(value) {
                this.userList=[]
                ss.MuBiao.selectUser(value).then(res => {
                    console.log(res.obj)
                    this.userList = res.obj
                    this.add.userCode = res.obj[0].usercode
                })
            },
            changeUser(value){
                this.addEditFrom.dbrcode = value.usercode;
                this.addEditFrom.dbrname = value.username;
            },
            //产品名称选择回调
            productChange(e) {
                if (e) {
                    this.$set(this.addEditFrom, 'materialName', e.levelname);//产品名称
                    this.$set(this.addEditFrom, 'materialCode', e.id);//产品编码
                } else {
                    this.$set(this.addEditFrom, 'materialName', '');//产品名称
                    this.$set(this.addEditFrom, 'materialCode', '');//产品编码
                }
            },
            productCode(e){
                if (e) {
                    this.$set(this.addEditFrom, 'materialCode', e.id);//产品编码
                    this.$set(this.addEditFrom, 'materialName', e.levelname);//产品名称
                } else {
                    this.$set(this.addEditFrom, 'materialCode', '');//产品编码
                    this.$set(this.addEditFrom, 'materialName', '');//产品名称
                }
            },
            callFun(obj) {
                console.log(obj)
                let id = this.addEditFrom.oneLid;
                this.$set(this.addEditFrom, 'prodseries', obj.name); //产品大类名称
                this.$set(this.addEditFrom,'oneLid', obj.code);
                this.$set(this.addEditFrom,'materialName', null);
                this.$set(this.addEditFrom,'materialCode', null);
                id && this.selectProduct2Cg(id)
            },
            selectProduct2Cg(id) {
                ss.ProService.product2OemSelect(id).then(rd => {
                    this.productNameArr = rd;
                    this.proudctLevelArr = rd
                })
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.id = null;
                this.f.supplierName = null;
                this.f.supplierCode = null;
                this.f.areaName = null;
                this.$refs[formName].resetFields();
            },
            //新增
            submit() {
                //提交
                let obj = JSON.parse(JSON.stringify(this.addEditFrom))
                //新增
                if (this.addEditFrom.optionsType === 'add') {
                    ss.chanpin.insertProductControl(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                } else if (this.addEditFrom.optionsType === 'edit') {
                    //修改
                    ss.chanpin.updateProductControl(obj).then(res => {
                        if (res.f == true) {
                            this.$message.success(res.msg);
                            this.dialogFormVisible = false;
                            this.query();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }
            },
            //勾选事件
            handleSelectionChange(val) {
              this.multipleSelection = val;
              var sum = 0;
              this.multipleSelection.forEach(element => {
                element.syNum = element.availableNum - element.proNumber;
                sum += element.includeTaxAmount;
              });
              //进行强制数据渲染
              this.$forceUpdate();
            },
            //删除
            handleDelete(value) {
            },
            //修改
            update(value) {
              this.saveorupdate = 2;
                ss.supplierAreaService.selectById(value.id).then(rd => {
                    console.log(rd,"rdrdrdrdrdrdrd");
                    this.dialogFormVisible = true;
                    this.f = rd.obj;
                })
            },
            //根据用户编码获取用户信息
            getUserName(){
                var usercode = this.f.jobUsercode;
                ss.UserService.selectById(usercode).then(rd => {
                    console.log("getUserName",rd)
                    this.f={
                        id:this.iditem,
                        jobUsercode:rd.obj.usercode,
                        jobUsername:rd.obj.username,
                        jobGroup:this.f.jobGroup,
                    }
                    console.log("getUserName123",rd)
                })
            },
            deleteSelete() {
              var idlist = [];
              this.multipleSelection.forEach(element => {
                idlist.push(element.id);
              });
              console.log(idlist)
              this.deleteSingle(idlist)
            },
            deleteSingle(id) {
              console.log("id", id)
              var data = id
              this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                ss.chanpin.deleteList(data).then(res => {
                  console.log(res)
                  if (res.f == true) {
                    this.$message({
                      type: 'success',
                      message: '删除成功!'
                    });
                    this.query()
                  } else {
                    this.$message.error(res.msg);
                  }
                })

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });

            },
            //批量导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/demo/bscProductControl/downloadExcel", this.q, "get",);
            },
            //选择地址
            selectAreadialog() {
              this.showdizhiflag = true;
            },
            choseDizhi(obj) {
              console.log("obj",obj);
              this.f.areaName = obj.quobj.namepath;
              this.f.areaId = obj.quobj.code;
              this.showdizhiflag = false;
            },
            getSupplier(value){
                ss.supplierAreaService.selectByUserName(value).then(res => {
                  console.log(res)
                  this.supplierList = res.obj
                  this.f.supplierName = res.obj[0].username
                  this.f.supplierCode = res.obj[0].usercode
                })
            },
          freezeList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            console.log(this.multipleSelection);
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.freezeList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("冻结成功！")
                this.query();
              }
            });
          },
          thawList(){
            if(this.multipleSelection.length==0){
              this.$message.error("请选择需要冻结的数据!");
              return;
            }
            let query = [];
            for(var i=0;i<this.multipleSelection.length;i++){
              let querys = {};
              querys.moduleEvidenceNum= this.multipleSelection[i].moduleEvidenceNum;
              querys.moduleItemNum = this.multipleSelection[i].moduleItemNum;
              querys.id = this.multipleSelection[i].id;
              querys.status = this.multipleSelection[i].status;
              querys.freezeUser = this.multipleSelection[i].freezeUser;
              querys.supplierCode = this.multipleSelection[i].supplierCode;
              query.push(querys);
            }
            console.log(query);
            ss.supplierAreaService.thawList(query).then(rd=> {
              console.log("rd",rd);
              if(rd.f){
                this.$msg.msgs("解冻成功！")
                this.query();
              }
            });
          },
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
    .el-table tbody td:last-child{
        border-left: 1px solid #c2d2db;
    }
</style>
<!--弹窗样式开始-->
<style scoped>
    .commodityMaintenanceBox > .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 3rem !important;
    }

    /deep/ .el-dialog__header {
        padding: 0
    }

    /deep/ .el-dialog {
        border-radius: 0.1rem;
        width: 7.89rem;
    }

    /deep/ .el-dialog__body {
        padding: 0;
    }

    /deep/ .el-dialog__header {
        background: #2785E7
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
        height: 0.56rem;
        width: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background-color: #fff;
        color: #015ba0;
        border-radius: 100%;
        font-size: 0.34rem;
    }

    .h-dialogImg {
        height: 1.62rem;
        background: url(/img/h-dialogImg.471fa846.png) center no-repeat;
        background-size: 7.89rem;
        padding-left: 4.02rem;
    }

    .h-dialogImg h3 {
        text-align: left;
        padding: .6rem 0 0 0;
        font-size: 0.3rem;
        color: #fff;
        font-weight: normal;
        letter-spacing: 0.02rem;
    }

    .addDeliveryForm {
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .addDeliveryForm /deep/ .el-form-item{
        width: 48%;
        float: left;
    }
    .addDeliveryForm /deep/ .el-form-item__label {
        width: 84px;
        font-size: 0.18rem;
        color: #4a4a4a;
        line-height: 0.28rem;
        vertical-align: top;
        padding-right: 5px;
        letter-spacing: 0;
        display: inline-block;
        text-align: right;
    }
    .addDeliveryForm /deep/ .el-form-item__content {
        width: 67%
    }
    .addDeliveryForm /deep/ .el-form-item__content .el-input__inner {
        border-radius: 0;
        background: transparent;
        color: #868686;
        border: 0;
        border-bottom: 1px solid #dedede;
        height: 0.29rem;
        line-height: 0.28rem;
        padding-left: 0.15rem;
    }

</style>
<!--弹窗样式结束-->